// extracted by mini-css-extract-plugin
export default {"container":"Jj-z","disabled":"Kj-z","subtotal":"Lj-z","legal":"Mj-z"};